import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]

interface AppFormGroupProps {
	id: string,
	label: string,
	errors?: string[],
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppFormGroup',
  props: {
    id: {},
    label: {},
    errors: { default: () => [] }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-group", {
			'is-invalid': __props.errors.length > 0,
		}])
  }, [
    _renderSlot(_ctx.$slots, "before"),
    _createElementVNode("label", {
      for: __props.id,
      class: _normalizeClass({'label-off-screen': !__props.label})
    }, _toDisplayString(__props.label), 11, _hoisted_1),
    _renderSlot(_ctx.$slots, "default"),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.errors, (error, i) => {
      return (_openBlock(), _createElementBlock("span", {
        key: i,
        class: "form-error"
      }, _toDisplayString(error), 1))
    }), 128))
  ], 2))
}
}

})